import React from "react";

import { StyledTooltip } from "../IyugaTooltip";
import {
  tierBadgeIcon,
  tierFeatureTooltip,
  tierTooltipColor,
} from "../../utils/tierTooltip";

/**
 * The paywall badge shown beside a gated control (tab label, panel header).
 *
 * Every visible property — copy, tooltip color, badge icon — is DERIVED from
 * the entitlement `useIfUserEligible(...)` returned, so the badge can never
 * name a different tier than the gate that produced it (or the Upgrade popup
 * the same click opens). See src/utils/tierTooltip.js for why the numeric tier
 * wins over the display name.
 *
 * Renders byte-identically to the hardcoded blocks it replaces whenever the
 * backend gates at the tier those strings assumed; it only diverges when the
 * hardcode was WRONG.
 *
 * @param {number} requiredSubscription `requiredSubscription` from useIfUserEligible
 * @param {string} subscription `subscription` (tier display name) from the same hook
 * @param {React.ReactNode} children optional custom trigger; defaults to the tier badge icon
 */
const TierFeatureBadge = ({
  requiredSubscription,
  subscription,
  placement = "bottom",
  size,
  onClick,
  style,
  children,
  ...tooltipProps
}) => {
  const title = tierFeatureTooltip(requiredSubscription, subscription);

  const iconStyle = {
    ...(size ? { width: size, height: size } : null),
    ...(onClick ? { cursor: "pointer" } : null),
    ...style,
  };

  return (
    <StyledTooltip
      title={title}
      arrow
      placement={placement}
      color={tierTooltipColor(requiredSubscription, subscription)}
      textColor={"#fff"}
      {...tooltipProps}
    >
      {children ?? (
        <img
          src={tierBadgeIcon(requiredSubscription, subscription)}
          alt={title}
          style={Object.keys(iconStyle).length ? iconStyle : undefined}
          onClick={onClick}
        />
      )}
    </StyledTooltip>
  );
};

export default TierFeatureBadge;
